<template>
  <div
    class="flex items-center gap-1"
    :class="isEditing || alwaysWrap ? 'flex-wrap' : 'flex-nowrap'"
  >
    <div
      v-for="tag in tags"
      :key="tag?.id"
      class="p-0.5 pl-2 bg-neutral-25 rounded-md flex items-center gap-1"
      :style="{ backgroundColor: tagColors[tag?.color]?.fill, color: tagColors[tag?.color]?.stroke }"
    >
      <BaseText
        type="label"
        size="sm"
        class="whitespace-nowrap truncate"
      >
        {{ tag?.value || 'Tag name not found' }}
      </BaseText>
      <button
        @click.stop="removeTag(tag)"
      >
        <TagRemoveIcon />
      </button>
    </div>

    <button
      v-if="!isAdding"
      class="p-0.5 pr-2 rounded-md border-border-normal border"
      @click="setEditingMode(true)"
    >
      <div
        class="flex items-center gap-0.5"
      >
        <PlusIcon class="text-icon-normal" />
        <BaseText
          type="label"
          size="sm"
          class="whitespace-nowrap text-text-muted"
        >
          Add a tag
        </BaseText>
      </div>
    </button>
    <div
      v-else
      v-on-clickaway="onInputBlur"
      class="flex items-center gap-0.5 relative"
    >
      <input
        ref="newTagInput"
        type="text"
        class="new-tag-input"
        placeholder=" Add a tag"
        :size="Math.max(8, newTag.length || 8)"
        :value="search"
        @input="onInputChange"
      >
    </div>
  </div>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway2'
import TAG_COLORS from '../../utils/TagColors'
// Icons
import PlusIcon from '../globals/Icons/PlusIcon.vue'
import TagRemoveIcon from '../globals/Icons/TagRemoveIcon.vue'
export default {
  name: 'LensTags',
  components: {
    PlusIcon,
    TagRemoveIcon
  },
  mixins: [clickaway],
  props: {
    tags: {
      type: Array,
      default: () => []
    },
    isEditing: {
      type: Boolean,
      default: false
    },
    search: {
      type: String,
      default: ''
    },
    alwaysWrap: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      newTag: '',
      isAdding: false,
      tagColors: TAG_COLORS
    }
  },

  methods: {
    setEditingMode (isAdding) {
      this.isAdding = isAdding
      this.$emit('addingStateChange', isAdding)
      if (isAdding) {
        this.$nextTick(() => {
          this.$refs.newTagInput.focus()
        })
      }
    },
    removeTag (tag) {
      console.log('remove tag', tag)
      this.$emit('removeTag', tag)
    },
    selectTag (tag) {
      this.newTag = tag
      this.isAdding = false
      this.$emit('addingStateChange', false)
    },
    onInputBlur () {
      this.isAdding = false
      this.$emit('addingStateChange', false)
    },
    onInputChange ($event) {
      this.$emit('updateTagSearch', $event.target.value)
    }
  }
}
</script>
<style scoped>
input {
  display: block;
}
.new-tag-input {
  width: auto;
  min-width: 95px;
  height: 26px;
  border: none;
  outline: none;
  outline-offset: 0;
  font-size: 14px;
  padding: 0.5px;
}
.new-tag-input:focus {
  outline: none !important;
  box-shadow: none !important;
  border: none !important;
}
.new-tag-input::placeholder {
  color: #A2ACBA;
}
</style>
